
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.44 6.97c0 5.03-6.47 9.34-6.47 9.34S.5 12 .5 6.97C.5 3.4 3.4.5 6.97.5s6.47 2.9 6.47 6.47z","stroke":"#1F4053","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.12 6.973c0 1.19-.97 2.16-2.16 2.16-1.19 0-2.16-.97-2.16-2.16 0-1.19.97-2.16 2.16-2.16 1.19 0 2.16.97 2.16 2.16z","stroke":"#1F4053","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    